import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import Dropdown from "../Dropdown";
import Button from "@material-ui/core/Button";
import Switch from "../Switch";
import MeetingEdit from "./MeetingEdit";
import { Link } from "react-router-dom";

const classes = {
	vCenter: {
		display: "flex",
		alignItems: "center"
	},
	textField: {
		width: "100%"
	},
	card: { padding: "20px" }
};

const currencies = [
	{
		value: "marketing",
		label: "Marketing"
	},
	{
		value: "tech",
		label: "Tech"
	},
	{
		value: "support",
		label: "Support"
	},
	{
		value: "lab",
		label: "Lab"
	}
];

export default class settings extends Component {
	state = {
		title: "Sample Meeting Title",
		venue: "CSE Building",
		type: "Tech",
		details: "lorem ipsum dolor sit amet",
		notes: "some dummy notes"
	};

	handleChange = () => {
		console.log("wow");
	};
	render() {
		return (
			<Paper style={classes.card}>
				<Grid container spacing={8}>
					<Grid item xs={8}>
						<MeetingEdit width="100%" />
					</Grid>
					<Grid item xs={4}>
						<div
							style={{
								border: "1px solid rgba(63, 81, 181, 0.5)",
								borderRadius: "5px",
								margin: "5px 0px",
								padding: 15
							}}
						>
							<Typography component="p">Meeting Code</Typography>
							<Typography variant="h5" component="h5" style={{ marginTop: 5 }}>
								DC1F4W
							</Typography>
							<Button
								variant="contained"
								size="small"
								color="primary"
								className={classes.margin}
								style={{ marginTop: 10 }}
							>
								<Link to="meeting-details">View Meeting</Link>
							</Button>
						</div>
						<Dropdown title="Meeting Privacy" />
						<Switch />
					</Grid>
				</Grid>
			</Paper>
		);
	}
}
